module.exports = __webpack_public_path__ + "static/img/play.4fd5a054.png";